import { Tabs } from '@mantine/core';
import { IconMicrophone, IconPhotoEdit } from '@tabler/icons-react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import TransactionManagement from './pages/admin/TransactionManagement';
import UserManagement from './pages/admin/UserManagement';
import { Login } from './pages/auth/Login';
import { Register } from './pages/auth/Register';
import { TextToSpeech } from './pages/TextToSpeech';
import { ThumbnailMaker } from './pages/ThumbnailMaker';
import { TokensPage } from './pages/TokensPage';

// Tạo component trang chủ sử dụng Tabs
const Home = () => (
  <Tabs defaultValue="tts">
    <Tabs.List>
      <Tabs.Tab value="tts" leftSection={<IconMicrophone size={16} />}>
        Text To Speech
      </Tabs.Tab>
      <Tabs.Tab value="thumbnail" leftSection={<IconPhotoEdit size={16} />}>
        Thumbnail Maker
      </Tabs.Tab>
    </Tabs.List>

    <Tabs.Panel value="tts" pt="md">
      <TextToSpeech />
    </Tabs.Panel>

    <Tabs.Panel value="thumbnail" pt="md">
      <ThumbnailMaker />
    </Tabs.Panel>
  </Tabs>
);

export function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected routes */}
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute>
                <UserManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/transactions"
            element={
              <ProtectedRoute>
                <TransactionManagement />
              </ProtectedRoute>
            }
          />

          {/* Home hiển thị tabs */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          
          {/* Giữ lại các route riêng biệt để có thể truy cập trực tiếp */}
          <Route
            path="/text-to-speech"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/thumbnail-maker"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/tokens"
            element={
              <ProtectedRoute>
                <TokensPage />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/tokens/:tokenType"
            element={
              <ProtectedRoute>
                <TokensPage />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/payment/success"
            element={
              <ProtectedRoute>
                <TokensPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App; 